var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-item has-dropdown has-dropdown-with-icons",class:{ 'is-hoverable':_vm.isHoverable, 'is-active':_vm.isDropdownActive },on:{"click":_vm.toggle}},[_c('a',{staticClass:"navbar-link is-arrowless"},[_vm._t("default"),_c('b-icon',{attrs:{"icon":_vm.toggleDropdownIcon,"custom-size":"default"}})],2),_vm._t("dropdown")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }